import { ASSETS } from "@/lib/assets";

export const BrandHeader = ({ right }) => (
  <header className="fea-header" data-testid="brand-header">
    <div className="fea-header-inner">
      <div className="flex items-center gap-3">
        <img src={ASSETS.logo} alt="Goddess University logo" className="h-12 w-12 sm:h-14 sm:w-14 object-contain" data-testid="brand-logo" />
        <div className="leading-tight">
          <p className="font-serif text-base sm:text-lg text-[#800534] tracking-wide">Goddess University</p>
          <p className="text-[10px] sm:text-[11px] uppercase tracking-[0.14em] sm:tracking-[0.22em] whitespace-nowrap text-[#B8902C]">Rev. Goddess LaMeel</p>
        </div>
      </div>
      {right}
    </div>
  </header>
);
